import { Container } from "./styles";

import reactIcon from "../../assets/react-icon.svg";
import linkedinIcon from "../../assets/linkedin.png";
import githubIcon from "../../assets/github.png";
import instagramIcon from "../../assets/instagram.png";
import discordIcon from "../../assets/discord.png";

export function Footer() {
    return (
        <Container className="footer">
            <a href="/" className="logo">
                <span>D</span>
                <span>evanandan</span>
            </a>
            <div>
                <p>
                    This site was made with a React lot of {" "}
                    <img src={reactIcon} alt="React" />Love
                    <span>❤️</span>
                </p>
            </div>

            <div className="social-media">
                <a
                    href="https://www.linkedin.com/in/devanandan-s-059239215/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img src={linkedinIcon} alt="Linkedin" />
                </a>

                <a
                    href="https://github.com/devanandan5"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img src={githubIcon} alt="GitHub" />
                </a>

                <a
                    href="https://www.instagram.com/__devan__xd?utm_medium=copy_link/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img src={instagramIcon} alt="Instagram" />
                </a>

               
            </div>
        </Container>
    );
}
